import React__default from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import StyledKMosaicElementNoBackground, { classes } from './index.styled.js';

var KMosaicElementNoBackground = function (_a) {
    var title = _a.title, className = _a.className, _b = _a.multiplier, multiplier = _b === void 0 ? 40 : _b, sx = _a.sx;
    return (React__default.createElement(StyledKMosaicElementNoBackground, { className: clsx("KMosaicElementNoBackground", className), sx: sx },
        React__default.createElement(Box, { className: classes.container }, Array.from(Array(multiplier), function (_, i) { return (React__default.createElement(Typography, { key: i, className: classes.typography, component: "span", variant: "h2" }, title)); }))));
};

export { KMosaicElementNoBackground as default };
//# sourceMappingURL=index.js.map
